import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const BeliefSection = () => (
    <section id="my-belief" className="min-h-screen flex flex-col justify-center bg-brand-black text-brand-black py-12 md:py-0 md:px-16 lg:h-screen overflow-visible lg:overflow-hidden relative">
        <div className="max-w-7xl mx-auto  grid grid-cols-1 md:grid-cols-2 gap-12  h-full items-center">
        <AnimatedElement className="w-full h-full flex flex-col justify-end">
        <img src=".\assets\img\ax-site-final7.png" alt="Won J. You" className="w-full h-full object-cover" />
        {/* <div className="mt-1 w-full h-2 rounded-full bg-red-600 "></div> */}
        <div className="w-full h-3 bg-red-600 rounded-full"></div>

        </AnimatedElement>

        <AnimatedElement className="w-full h-full flex flex-col justify-up">

            <div className="h-full flex flex-col justify-center  md:pr-12 p-0 m-0">
              
                    <p className="font-bold text-center" style={{fontFamily: 'pinar', color: '#ff2a3f' ,fontSize: "clamp(24px, 5vw, 40px)"}}>Why Work With Me</p>
                    <p className="text-lg md:text-xl leading-relaxed  " style={{ fontFamily: 'pinar', color: '#FFF' , textAlign: "justify", textAlignLast: "right", direction: "rtl" }}>
                    رویکرد من ساده و شفاف است ، هر <a style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>تصمیم</a> در برند باید ریشه در <a style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>استراتژی</a> داشته باشد. بجای راه حلهای سریع ، چارچوبی برای رشد بلندمدت طراحی می کنم ، چارچوبی که باعث می شود برند نه فقط دیده شود ، بلکه در <a style={{ fontFamily: 'pinar', color: '#ff2a3f' }}>ذهن مخاطب تثبیت</a> شود. 
در پروژه های ترکیبی از تجربه های B2B وB2C را بکار گرفته ام:
در B2B تمرکز بر ارزش اقتصادی ، ساختار همکاری و کیفیت خروجی است ، و در B2C تمرکز بر تجربه مخاطب و برند سازی.

                    </p>
                
            </div>
            </AnimatedElement>
        </div>
       
    </section>
);

export default BeliefSection;
